




















import { Component, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import TransactionHistory from '@/components/Accounts/Shared/History/TransactionHistory.vue';
import History from '@/components/Shared/History.vue';
import EntityType from '@/models/Shared/EntityType';

@Component({ name: 'HistorySubTabs', components: { History, TransactionHistory } })
export default class extends SaascadaVue {

    @Prop({required: true})
    entityType: EntityType;

}
